var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuInfant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2105 14.6072H26.7343L28.2722 32.0223C28.3543 32.9524 27.5766 33.75 26.5876 33.75H13.3572C12.3682 33.75 11.5905 32.9524 11.6726 32.0223L13.2105 14.6072Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18135",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 14,
    width: 18,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2105 14.6072H26.7343L28.2722 32.0223C28.3543 32.9524 27.5766 33.75 26.5876 33.75H13.3572C12.3682 33.75 11.5905 32.9524 11.6726 32.0223L13.2105 14.6072Z",
    fill: "#CCCCCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0833 35L11.6666 14.1666V35H32.0833Z",
    fill: "#C6C6C6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.789 5.83337C18.5089 5.83337 18.2836 6.04777 18.2586 6.31103C18.039 8.62437 16.2911 11.5087 14.045 12.1039C13.5955 12.223 13.2104 12.5714 13.2104 13.0119V14.6072H26.7343V13.0119C26.7343 12.5714 26.3492 12.223 25.8997 12.1039C23.6536 11.5087 21.9057 8.62437 21.6861 6.31103C21.6611 6.04777 21.4358 5.83337 21.1557 5.83337H18.789Z",
    fill: "#FF791C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuInfant);
export default __webpack_public_path__ + "static/media/wikiMenuInfant.9ca278e05c8f301ad8bbb4ac5b257e45.svg";
export { ForwardRef as ReactComponent };